import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { EmailCreateTabManagerService } from '@services/email-create-tab-manager.service';

@Component({
  selector: 'wsb-redirect-back-from-editor',
  templateUrl: './redirect-back-from-editor.component.html',
  styleUrls: ['./redirect-back-from-editor.component.scss'],
  standalone: false
})
export class RedirectBackFromEditorComponent implements OnInit {
  constructor(private route: ActivatedRoute, private router: Router, public emailCreateTabManagerService: EmailCreateTabManagerService) {}

  ngOnInit(): void {
    this.checkRoute();
  }

  checkRoute() {
    this.route.queryParams.subscribe(params => {
      if (params.issue) {
        this.router.navigate(['mail/send'], { queryParams: { issue: params.issue, step: 2 } });
      }
    });
  }
}
